import ArtPlaceholder from "./ArtPlaceholder";
import { fmtDate } from "../utils/format";
import "../styles/ClassCard.css";

function isVideo(item) {
  return item?.mediaType === "video" || (item?.img && String(item.img).startsWith("data:video"));
}

export default function ClassCard({ item }) {
  const video = isVideo(item);
  return (
    <div className="class-card">
      <div className="class-card-img">
        {item.img && video ? (
          <video src={item.img} controls playsInline muted />
        ) : item.img ? (
          <img src={item.img} alt={item.title} />
        ) : (
          <ArtPlaceholder />
        )}
      </div>
      <div className="class-card-body">
        <div className="class-card-date">{fmtDate(item.date)}</div>
        <div className="class-card-title">{item.title}</div>
        {item.desc && <div className="class-card-desc">{item.desc}</div>}
      </div>
    </div>
  );
}
